export const CART = 'CART';
